<template lang="pug">
study-start.study-top(
  :title='title',
  :category='category',
  :isLearned='isLearned',
  :moveReturnEvent='moveReturnEvent',
  :startButtonEvent='startButtonEvent'
)
  template(#returnButtonText) 戻る
  template(#lastMinuteCheckTitleText) 直前チェックCBT
  template(#resolveTitleText) 解きなおしCBT
  template(#startButtonLabel) テストをはじめる
  template(#retryAllButtonLabel) もう一度全問チャレンジする
  template(#retryMistakeButtonLabel) 間違えた問題だけチャレンジする
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import StudyStart from '@/components/templates/student/StudyStart.vue'
import { StudySelectionUtils } from '@/utils/StudySelectionUtils'
import DrillApi from '@/mixins/api/DrillApi'
import StudentCurriculumSUnitsApi from '@/mixins/api/student/StudentCurriculumSUnitsApi'
import { SUnitCategorySetting } from '@/const/ApiSettings'

/**
 * テスト扉画面
 */
@Component({
  components: {
    StudyStart,
  },
})
export default class StudyTop extends Mixins(DrillApi, StudentCurriculumSUnitsApi) {
  // 小項目IDをクエリーより取得
  private get sUnitId(): number {
    return Number(this.$route.query.sUnitId)
  }

  // 学習済みフラグをクエリーより取得
  private get isLearned(): boolean {
    // 解きなおし時は常に学習済み扱いとなる
    return String(this.$route.query.isLearned) === 'true' || this.category === SUnitCategorySetting.RESOLVE
  }

  // カテゴリー（直前チェックCBT/解きなおしCBT）
  private category: SUnitCategorySetting | null = null

  // タイトル文字列
  private title = ''

  /**
   * [Vue] 画面読み込み時：初期処理
   */
  private async mounted(): Promise<void> {
    this.$loading.start()
    const sUnitInfo = await this.getStudentCurriculumSUnit(this.sUnitId)
    this.category = StudySelectionUtils.getSUnitCategory(sUnitInfo)
    this.title = StudySelectionUtils.getSUnitStudyName(sUnitInfo)
    this.$loading.complete()
  }

  // 戻るボタン押下時イベント
  private moveReturnEvent() {
    this.$router.push({ name: 'StudentStudySelection' })
  }

  // 学習開始ボタンイベント
  private async startButtonEvent(isOnlyMistake?: boolean) {
    if (!this.sUnitId) {
      return
    }

    this.$loading.start()
    try {
      // 小項目ID、学習済みフラグ、間違い直し用フラグを用いて学習結果IDを取得
      const apiResponse = await this.drillStartApi(this.sUnitId, !this.isLearned, isOnlyMistake || false)
      const resultDrillId = StudySelectionUtils.getStartResultDrillId(apiResponse)
      this.$loading.complete()
      // 学習結果IDを付与してテスト画面へ遷移
      this.$router.push({ name: 'StudentStudy', query: { resultDrillId: String(resultDrillId) } })
    } catch (error: any) {
      if (error.response && error.response.status === 400) alert(error.response.data.message)
    }
  }
}
</script>
